var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82149 10L5.28711 6.46562C4.96167 6.14018 4.96167 5.61254 5.28711 5.28711C5.61254 4.96167 6.14018 4.96167 6.46562 5.28711L10 8.82149L13.5344 5.28711C13.8598 4.96167 14.3874 4.96167 14.7129 5.28711C15.0383 5.61254 15.0383 6.14018 14.7129 6.46562L11.1785 10L14.7129 13.5344C15.0383 13.8598 15.0383 14.3874 14.7129 14.7129C14.3874 15.0383 13.8598 15.0383 13.5344 14.7129L10 11.1785L6.46562 14.7129C6.14018 15.0383 5.61254 15.0383 5.28711 14.7129C4.96167 14.3874 4.96167 13.8598 5.28711 13.5344L8.82149 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0133b3aff8b0236750bdad4352c12e51.svg";
export { ForwardRef as ReactComponent };